export default __webpack_public_path__ + "static/media/Bloodseer's Wristbands.23dcadc7.jpg";